import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Clock, BatteryWarning, TrendingDown } from 'lucide-react';
export function PainSection() {
  const painPoints = [{
    icon: <Clock className="w-8 h-8 text-red-500" data-id="element-171" />,
    title: 'El tiempo se escurre',
    desc: "¿Te pasó de estar cenando con tu familia y no poder soltar el celular porque 'entró una consulta'?"
  }, {
    icon: <TrendingDown className="w-8 h-8 text-red-500" data-id="element-172" />,
    title: 'Ventas perdidas',
    desc: '¿O despertarte con 40 mensajes y saber que la mitad ya le compró a la competencia por no responder a tiempo?'
  }, {
    icon: <BatteryWarning className="w-8 h-8 text-red-500" data-id="element-173" />,
    title: 'Desgaste mental',
    desc: "Estás atrapado respondiendo las mismas 50 preguntas: '¿Precio?', '¿Talle?', '¿Cuándo llega?'."
  }, {
    icon: <Smartphone className="w-8 h-8 text-red-500" data-id="element-174" />,
    title: 'El dilema del dueño',
    desc: 'Si no respondés, no crecés; si respondés todo, no tenés vida. Contratar a alguien hoy es un riesgo enorme.'
  }];
  return <section className="py-14 px-4 bg-[#0f0f0f] border-y border-white/5 relative" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-177">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-178">
            El modelo tradicional de "atender el WhatsApp"{' '}
            <span className="text-red-500" data-id="element-179">te está matando.</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-180">
            Si sos dueño de un comercio o servicio en Argentina, sabés que el
            que no responde rápido, no vende. Pero vos no podés estar despierto
            las 24 horas. <strong className="text-[#25D366]" data-id="element-181">Tu IA sí.</strong>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-182">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#161616] p-8 rounded-2xl border border-white/5 hover:border-red-500/30 transition-colors group" data-id="element-183">
              <div className="bg-red-500/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-184">
                {point.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-185">
                {point.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-186">{point.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 p-8 bg-gradient-to-r from-red-900/20 to-transparent border-l-4 border-red-500 rounded-r-2xl" data-id="element-187">
          <p className="text-xl md:text-2xl text-white font-medium italic" data-id="element-188">
            "Es frustrante ver cómo tu tiempo se drena en tareas que una máquina
            podría hacer en milisegundos."
          </p>
        </motion.div>
      </div>
    </section>;
}